import { Button } from '@/components/ui/button';
import { Check, X } from 'lucide-react';
import { useEffect } from 'react';

interface Props {
    toolLabel: string;
    onDecide: (approved: boolean) => void;
}

export default function ToolApprovalDock({ toolLabel, onDecide }: Props) {
    useEffect(() => {
        const onKey = (event: KeyboardEvent) => {
            if ((event.target as HTMLElement).closest('input, textarea, [contenteditable]')) return;
            if (event.key.toLowerCase() === 'y') onDecide(true);
            if (event.key.toLowerCase() === 'n') onDecide(false);
        };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    });

    return (
        <div className="mb-2 flex items-center justify-between gap-4 rounded-xl border bg-white px-4 py-3 composer-shadow dark:bg-sidebar-accent">
            <span className="text-sm">
                Allow to use <span className="font-medium">{toolLabel}</span>?
            </span>
            <div className="flex shrink-0 gap-2 text-sm">
                <Button
                    variant="tertiary"
                    size="compact"
                    onClick={() => onDecide(false)}
                >
                    <X /> Deny
                </Button>
                <Button size="compact" onClick={() => onDecide(true)}>
                    <Check /> Allow
                </Button>
            </div>
        </div>
    );
}
